import {$, jquery} from "jquery";
globalThis.jQuery = $;
